import React from "react";
import "./TeachingLanding.css";
import TeacherBanner from "../../Components/TeacherBanner/TeacherBanner";
import TeacherInstruction from "../../Components/TeacherInstruction/TeacherInstruction";
import FAQ from "../FAQ/FAQ";

const TeachingLanding = () => {
  return (
    <div className="teaching-container">
     <TeacherBanner />
     <TeacherInstruction />
     <FAQ />
    </div>
  );
};

export default TeachingLanding;
